"use client";

import { Links } from "./Links";

export const Sidebar = () => {
    return (
        <>
            <div className="hidden md:flex flex-col h-full w-fit pr-2 bg-gray-900">
                <h1 className="hidden md:inline-block px-6 py-4 text-white">Menu</h1>
                <div className="flex flex-col gap-y-4 px-8">
                    <Links />
                </div>
            </div>
        </>
    );
};